import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const CompletedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M21.1787,9.1663C21.1787,4.1125,17.0615.0007,12.0005.0007S2.8213,4.1125,2.8213,9.1663c0,3.0054,1.4628,5.6696,3.7078,7.3422l-1.3406,3.9507,3.209-.8623,2.0225,2.6318,1.2648-3.7291,1.8094,5.4996,2.416-3.084,3.7783,1.0518-1.8797-5.7107c2.0554-1.6824,3.3699-4.2355,3.3699-7.0901ZM10.0732,20.137l-1.29-1.6787-2.0459.5498.6541-1.928c1.0048.5859,2.1287.9838,3.328,1.1522l-.6461,1.9047ZM3.8213,9.1663C3.8213,4.6638,7.4902,1.0007,12.0005,1.0007s8.1782,3.6631,8.1782,8.1655-3.6689,8.166-8.1782,8.166S3.8213,13.6692,3.8213,9.1663ZM18.1533,20.5022l-2.6182-.7295-1.6758,2.1387-1.1884-3.613c1.5716-.1143,3.0329-.6221,4.287-1.4301l1.1953,3.634Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M12.0005,2.5388c-3.6597,0-6.6372,2.9731-6.6372,6.6274s2.9775,6.6279,6.6372,6.6279,6.6362-2.9731,6.6362-6.6279-2.9766-6.6274-6.6362-6.6274ZM12.0005,14.7942c-3.1084,0-5.6372-2.5249-5.6372-5.6279s2.5288-5.6274,5.6372-5.6274,5.6362,2.5244,5.6362,5.6274-2.5283,5.6279-5.6362,5.6279Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M15.9229,6.5417c-.1953-.1953-.5117-.1948-.707-.0005l-4.605,4.5981-1.8921-1.8901c-.1953-.1943-.5122-.1948-.7075.0005-.1948.1958-.1948.5122.0005.7075l2.5991,2.5952,5.312-5.3032c.1953-.1953.1953-.5117,0-.7075Z"
      className="accent"
    />
  </svg>
);
export default withCustomIcon(CompletedIcon);
